import { HttpClient } from '@angular/common/http';
import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { UserService } from './core/user/user.service';
import { environment } from 'environments/environment';

/** Response shape for POST /api/Currency/initialize */
interface CurrencyInitializeResult {
    companyId: string;
    inserted: number;
    updated: number;
    totalActive: number;
    baseCurrencyId: string;
    baseCurrencyCode: string;
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly _destroyRef = inject(DestroyRef);
    constructor(
        private _userService: UserService,
        private _httpClient: HttpClient
    ) {}

    ngOnInit(): void {
        // const url = `${environment.apiUrl}Currency/initialize`;
        // this._httpClient.post<CurrencyInitializeResult>(url, null).pipe(takeUntilDestroyed(this._destroyRef)).subscribe();
    }

    ngAfterViewInit(): void {
        const splash = document.getElementById('app-splash');

        if (splash) {
            splash.remove();
        }
    }

}
